import { useTrackItemsSubmittedAnalytics } from '../../../hooks/bi/useTrackItemsSubmittedAnalytics';
import { createHOCWithHookInside } from '../../createHOCWithHookInside';

/**
 * @deprecated use "useTrackItemsSubmittedAnalytics"
 */
export const withItemsSubmittedAnalytics = createHOCWithHookInside(
  'WithItemsSubmittedAnalytics',
  useTrackItemsSubmittedAnalytics,
);
